import React from 'react';
import styles from './sidebar.module.scss';
import { icons } from '../../../images/Icons';
import useTranslation from 'next-translate/useTranslation';
import { LinkData } from '../../helpers/common';
import Link from 'next/link';
import { getFlyersLink, getCouponsLink } from '../../helpers/links';
import { useRouter } from 'next/router';
import { isRuntimeSDE } from '../../hooks/useConfig';

interface SidebarProps {
  categories: LinkData[];
  location: string;
}
export default function Sidebar({ categories, location }: SidebarProps): JSX.Element {
  const { t } = useTranslation('application');
  const router = useRouter();

  const locale = router.locale;
  const postalCode = '777';
  const flyersForPostalCode = t('flyers_for_postal_code', {
    postalCode,
  });

  function renderCategoriesList(): JSX.Element {
    return (
      <ul style={{ marginLeft: '-35px' }}>
        <h2 className={styles.categoriesTitle}>Flyers</h2>
        {categories &&
          categories.map((link: LinkData) => (
            <div key={link.id}>
              <li className={styles.link}>
                <Link href={link.link} legacyBehavior>
                  {link.name}
                </Link>
              </li>
            </div>
          ))}
      </ul>
    );
  }

  function renderFlyersNavLinks(): JSX.Element {
    return (
      <>
        <div className={styles.link}>
          <div className={styles.linkLogoContainer}>
            <img
              className={styles.linkLogo}
              src="https://f.wishabi.net/creative/Distribution/images/icons/favourite-outline-default5.svg"
              alt=""
            />
          </div>
          <span>{t('fav_page')}</span>
        </div>
        <div className={styles.link}>
          <div className={styles.linkLogoContainer}>
            <img
              className={styles.linkLogo}
              src="https://f.wishabi.net/creative/Distribution/images/icons/browse-outline-default5.svg"
              alt=""
            />
          </div>
          <Link href={getFlyersLink(locale, location)} legacyBehavior>
            {t('flyers')}
          </Link>
        </div>
        <div className={styles.link}>
          <div className={styles.linkLogoContainer}>
            <img
              className={styles.linkLogo}
              src="https://f.wishabi.net/creative/Distribution/images/icons/coupon-outline-default5.svg"
              alt=""
            />
          </div>
          <Link href={getCouponsLink(locale, location)} legacyBehavior>
            {t('coupons')}
          </Link>
        </div>
      </>
    );
  }

  return (
    <nav className={styles.sidebar}>
      {!isRuntimeSDE() && (
        <div>
          <a href="/" className={styles.logo} title="Flipp">
            {icons.flippLogo}
          </a>
        </div>
      )}
      <button className={styles.location}>
        <img
          className={styles.icon}
          src="https://f.wishabi.net/creative/Distribution/images/icons/location-01-default5.svg"
          alt=""
        />
        <div>
          {flyersForPostalCode}
          <br />
          <span>({t('change_location')})</span>
        </div>
      </button>

      {!isRuntimeSDE() && renderFlyersNavLinks()}
      {renderCategoriesList()}
    </nav>
  );
}
